import React from 'react'
import styled from 'styled-components'
import Text from './Text'
import { Star } from './Stars'
import styles from '../../utility/styles'
import { tech_crunch, gizmodo, unece_logo, yahoo } from '../../utility/icons'

// [claude] Compact social-proof band for the Ink design system: store ratings and
// press logos on one quiet hairline row. Extracted from Subscribe.js (2026-07) so
// Home and other marketing pages render the identical strip. Pass the `ratings`
// hash built by PagesController#serialize_app_store_ratings.

const Strip = styled.div`
	border-top: 1px solid ${({ theme }) => theme.border};
	border-bottom: 1px solid ${({ theme }) => theme.border};
	margin-bottom: 72px;
`

const StripInner = styled.div`
	max-width: 1320px;
	margin: 0 auto;
	padding: 14px 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 28px;
	flex-wrap: wrap;
`

const Item = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	white-space: nowrap;
`

const Logos = styled.div`
	display: flex;
	align-items: center;
	gap: 32px;
	flex-wrap: wrap;
	justify-content: center;
`

// Matches the homepage's original dimmed press-logo treatment.
const PressLogo = styled.div`
	position: relative;
	background: center / contain url(${({ src }) => src}) no-repeat;
	width: 96px;
	height: 22px;
	opacity: ${({ theme }) => (theme.name === 'light' ? 0.75 : 0.55)};
	filter: ${({ theme }) => (theme.name === 'light' ? 'invert(0.82)' : 'none')};
`

export default function ProofStrip({ ratings = {} }) {
	const hasRatings = !!ratings?.apple_rating || !!ratings?.google_rating
	if (!hasRatings) return null
	return (
		<Strip>
			<StripInner>
				{!!ratings.apple_rating && (
					<Item>
						<Star fraction={1} id='proof-apple' scale={0.7} colors={{ background: 'transparent', foreground: styles.colors.founders }} />
						<Text.Caption color={styles.colors.dimHighlight} variant='bold' style={{ fontVariantNumeric: 'tabular-nums' }}>{ratings.apple_rating}</Text.Caption>
						<Text.Caption color={styles.colors.mediumGray}>App Store ({ratings.apple_num_reviews})</Text.Caption>
					</Item>
				)}
				{!!ratings.google_rating && (
					<Item>
						<Star fraction={1} id='proof-google' scale={0.7} colors={{ background: 'transparent', foreground: styles.colors.founders }} />
						<Text.Caption color={styles.colors.dimHighlight} variant='bold' style={{ fontVariantNumeric: 'tabular-nums' }}>{ratings.google_rating}</Text.Caption>
						<Text.Caption color={styles.colors.mediumGray}>Google Play ({ratings.google_num_reviews})</Text.Caption>
					</Item>
				)}
				<Logos>
					<PressLogo src={tech_crunch} />
					<PressLogo src={gizmodo} />
					<PressLogo src={unece_logo} />
					<PressLogo src={yahoo} />
				</Logos>
			</StripInner>
		</Strip>
	)
}
